<template>
    <span v-if="simple && noLink">
        {{ displayText }}
    </span>
    <a v-else-if="simple" :href="`tel:${parsedPhone}`">
        {{ displayText }}
    </a>
    <div v-else class="flex truncate flex-nowrap items-center" v-bind="$attrs" v-on="$listeners">
        <vx-basic-icon
            v-if="!hideIcon"
            class="mr-3"
            :icon="mobile ? 'SmartphoneIcon' : 'PhoneIcon'"
        />
        <template v-if="hasPhone && isValid">
            <span v-if="noLink">
                {{ displayText }}
            </span>
            <a v-else :href="`tel:${parsedPhone}`">
                {{ displayText }}
            </a>
        </template>
        <span v-else class="disabled" :class="{ 'text-danger': !isValid }">
            {{ parsedPhone }}
            <span v-if="!isValid">*</span>
        </span>
        <slot name="append"></slot>
    </div>
</template>

<script>
import { VueMaskFilter } from 'v-mask'
import { phone, character } from '@/plugins/helpers/regex_helpers'

const keyPads = {
    '1': '1',
    '2': '2',
    '3': '3',
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
    '8': '8',
    '9': '9',
    '0': '0',
    'a': '2',
    'b': '2',
    'c': '2',
    'd': '3',
    'e': '3',
    'f': '3',
    'g': '4',
    'h': '4',
    'i': '4',
    'j': '5',
    'k': '5',
    'l': '5',
    'm': '6',
    'n': '6',
    'o': '6',
    'p': '7',
    'q': '7',
    'r': '7',
    's': '7',
    't': '8',
    'u': '8',
    'v': '8',
    'w': '9',
    'x': '9',
    'y': '9',
    'z': '9',
    '+': '+'
}

export default {
    name: 'vx-phone',
    filters: {
        VMask: VueMaskFilter
    },
    props: {
        value: {
            type: String
        },
        hideIcon: {
            type: Boolean,
            default: false
        },
        mobile: {
            type: Boolean,
            default: false
        },
        noLink: {
            type: Boolean,
            default: false
        },
        internationalize: {
            type: Boolean,
            default: false
        },
        simple: {
            type: Boolean,
            default: false
        },
        allowAlpha: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    methods: {
        parseAlphaPhone(number) {
            var chars = number.toLowerCase().split('')
            return chars.map((c) => keyPads[c] || '').join()
        }
    },
    computed: {
        displayText() {
            if (!this.allowAlpha) {
                return this.$options.filters.VMask(this.parsedPhone, this.mask)
            }

            if (character.ALPHA_REGEX.test(this.value)) {
                return this.value
            }
            return this.parsedPhone
        },
        trimmedPhone() {
            var result = this.value || ''
            if (this.allowAlpha) {
                result = this.parseAlphaPhone(result)
            }
            return result.replace(/[^\d+()]/g, '')
        },
        isMobile() {
            if (!this.hasPhone) {
                return false
            }
            if (this.mobile) {
                return true
            }
            return (
                this.trimmedPhone.startsWith('04') ||
                this.trimmedPhone.startsWith('+614') ||
                this.trimmedPhone.startsWith('+6104')
            )
        },
        hasPhone() {
            return !!this.trimmedPhone
        },
        parsedPhone() {
            if (!this.hasPhone) {
                return `No ${this.mobile ? 'mobile' : 'phone'}`
            }
            if (this.internationalize) {
                return this.trimmedPhone.asInternationalPhone()
            }
            return this.trimmedPhone.asLocalPhone()
        },
        isValid() {
            return phone.AUS_REGEX.test(this.parsedPhone)
        },
        mask() {
            if (!this.parsedPhone) {
                if (this.mobile) {
                    return '#### ### ###'
                } else {
                    return '(##) #### ####'
                }
            }

            if (this.parsedPhone.length >= 3) {
                // Australian mobile number
                if (this.parsedPhone.startsWith('04') || this.parsedPhone.startsWith('13')) {
                    return '#### ### ###'
                }

                // International code is set
                if (this.parsedPhone.startsWith('+')) {
                    if (this.parsedPhone.startsWith('+61')) {
                        if (this.mobile) {
                            return '+## ### ### ###'
                        }
                        return '+### #### ####'
                    } else if (this.parsedPhone.startsWith('+1')) {
                        return '+#-###-###-####'
                    } else if (this.parsedPhone.startsWith('+7')) {
                        return '+#-###-###-##-##'
                    } else if (this.parsedPhone.startsWith('+44')) {
                        return '+## #### ######'
                    } else if (this.parsedPhone.startsWith('+63')) {
                        return '+## (###) ### ####'
                    }
                    return '+XXXXXXXXXXXXXX'
                }

                if (this.parsedPhone.startsWith('0') || this.parsedPhone.startsWith('(')) {
                    return '(##) #### ####'
                } else if (this.parsedPhone.length < 9) {
                    return '#### ####'
                }
            }
            return 'XXXXXXXXXXXXXXX'
        }
    }
}
</script>
